export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const ENV = import.meta.env.VITE_ENV;
export const GOOGLE_API_KEY = import.meta.env.VITE_PUBLIC_GOOGLE_API_KEY;
export const JWT_APP_V1 = import.meta.env.VITE_JWT_APP_V1;
export const API_V1_URL = import.meta.env.VITE_API_V1_URL;
export const LIBHEROS_DEEPLINK_URL = import.meta.env.VITE_LIBHEROS_DEEPLINK_URL;
